import axios from 'axios';
import { APP_URL_API } from '../../setup/configs'

export default class AuthService {
    // Initializing important variables
    constructor(domain) {
        this.domain = domain || APP_URL_API // API server domain
        this.fetch = this.fetch.bind(this) // React binding stuff
        this.login = this.login.bind(this)
        this.getProfile = this.getProfile.bind(this)
    }

    login(username, password) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}auth/token`, {
            method: 'POST',
            body: JSON.stringify({
                username,
                password
            })
        }).then(res => {
            this.setToken(res.data.token, res.data.expires_at) // Setting the token in sessionStorage
            sessionStorage.setItem('privacy', 'rejected');
            return Promise.resolve(res);
        }).catch(function() {
            alert('Brugernavn eller adgangskode er forkert. Tjek at du har indtastet oplysningerne korrekt. Ved glemt logininformation læs mere i infotekst under loginfelterne.');
        })
    }

    loggedIn() {
        // Checks if there is a saved token and it's still valid
        const token = this.getToken() // GEtting token from localstorage
        return !!token && !this.isTokenExpired() // handwaiving here
    }

    isTokenExpired() {
        const expiredAt = new Date(sessionStorage.getItem('expires_at')).getTime();
        try {
            if (expiredAt < Date.now()) { // Checking if token is expired.
                return true;
            }
            else
                return false;
        }
        catch (err) {
            return false;
        }
    }

    isTokenAboutToExpire() {
        const expiredAt = new Date(sessionStorage.getItem('expires_at')).getTime();
        const timeToExpire = ((expiredAt - Date.now())/1000)/60;
        try {
            if (timeToExpire <= 5) { // Checking if token is expired.
                return true;
            }
            else
                return false;
        }
        catch (err) {
            return false;
        }
    }

    refreshToken() {
        this.fetch(`${this.domain}auth/refresh`, {
            method: 'GET',
        }).then(res => {
            this.setToken(res.data.token, res.data.expires_at) // Setting the token in sessionStorage
            return Promise.resolve(res);
        })
    }

    setToken(idToken, expiresAt) {
        // Saves user token to sessionStorage
        sessionStorage.setItem('id_token', idToken);
        sessionStorage.setItem('expires_at', expiresAt);
    }

    getToken() {
        // Retrieves the user token from sessionStorage
        return sessionStorage.getItem('id_token')
    }

    logout() {
        // Clear user token and profile data from sessionStorage
        sessionStorage.removeItem('id_token');
        sessionStorage.removeItem('expires_at');
    }

    getProfile() {
        // Using jwt-decode npm package to decode the token
        // return decode(this.getToken());
        const config = { 'Authorization': 'Bearer '+ this.getToken()};
        const url = `${this.domain}/auth/user`;

        return this.serverRequest =
            axios
                .get(url, {headers: config})
                .then(function(result) {
                    return result
                })
    }

    fetch(url, options) {
        // performs api calls sending the required authentication headers
        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }

        // Setting Authorization header
        // Authorization: Bearer xxxxxxx.xxxxxxxx.xxxxxx
        if (this.loggedIn()) {
            headers['Authorization'] = 'Bearer ' + this.getToken()
        }

        return fetch(url, {
            headers,
            ...options
        })
            .then(this._checkStatus)
            .then(response => response.json())
    }

    _checkStatus(response) {
        // raises an error in case response status is not a success
        if (response.status >= 200 && response.status < 300) { // Success status lies between 200 to 300
            return response
        } else {
            var error = new Error(response.statusText)
            error.response = response
            throw error
        }
    }
}


// WEBPACK FOOTER //
// ./src/modules/auth/AuthService.js